<template>
  <pict
    class="z-50 absolute left-2 top-5 m:-left-24 m:top-0"
    block-name="arrow-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "../images/arrow.png"
import imageL2x from "../images/arrow@2x.png"
import imageS from "../images/arrow_s.png"
import imageS2x from "../images/arrow_s@2x.png"

export default {
  name: "ArrowImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          },
          {
            media: "m",
            src: imageL,
            srcset: {
              "2x": imageL2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "An arrow pointing from a collection of avatars to the category explorer below"
      },
      de: {
        alt: "Ein Pfeil, der von einem Bild mit Avataren zu dem Kategorieexplorer zeigt"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.book-share {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
